var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseActions } from '../shared/base-actions';
import { takeUntil } from 'rxjs/operators';
var ChangeLogComponent = /** @class */ (function (_super) {
    __extends(ChangeLogComponent, _super);
    function ChangeLogComponent(httpClient) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.items = [];
        document.body.classList.add('disable-hidden-overflow');
        return _this;
    }
    ChangeLogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.httpClient.get('/assets/changelog.json').pipe(takeUntil(this.stopSubscription)).subscribe(function (items) {
            _this.items = items;
        });
    };
    return ChangeLogComponent;
}(BaseActions));
export { ChangeLogComponent };
